import React from "react";
import { Dialog } from "primereact/dialog";

import { Button } from "@/components/atoms/prime/Button";
import { cn } from "@/styles/cn";

export type ConfirmModalProps = {
  children: React.ReactNode;
  reject: () => void;
  accept: () => void;
  open?: boolean;
  acceptLabel?: string;
  acceptDisabled?: boolean;
  rejectLabel?: string;
  isLoading?: boolean;
  title?: React.ReactNode;
  variant?: "default" | "danger";
};

const ConfirmModal = ({
  children,
  reject,
  accept,
  open = true,
  acceptLabel = "Aceptar",
  acceptDisabled = false,
  rejectLabel = "Cancelar",
  title,
  isLoading,
  variant = "default",
}: ConfirmModalProps) => {
  const footer = () => {
    return (
      <>
        <Button
          disabled={isLoading}
          label={rejectLabel}
          severity="secondary"
          tabIndex={2}
          onClick={() => reject()}
        />
        <Button
          autoFocus
          disabled={acceptDisabled}
          label={acceptLabel}
          loading={isLoading}
          pt={{
            root: {
              className: cn("min-w-[90px]", {
                "bg-red-500 border-red-500 hover:bg-red-700 hover:border-red-700":
                  variant === "danger",
              }),
            },
          }}
          tabIndex={1}
          onClick={() => {
            accept();
          }}
        />
      </>
    );
  };

  return (
    <Dialog
      closable={false}
      footer={footer}
      header={title}
      pt={{
        root: { className: "text-center w-fit" },
        header: {
          className: "p-6 pb-2 text-center flex text-rdc-primary text-[1.125rem]",
          role: "heading",
        },
        content: {
          className: "p-6 pt-2 pb-2 font-bold text-[0.875rem] text-rdc-gray",
          role: "main-container",
        },
        footer: { className: "justify-center gap-4 flex pb-6" },
      }}
      visible={open}
      onHide={() => reject()}
    >
      {children}
    </Dialog>
  );
};

export default ConfirmModal;
